import { render, staticRenderFns } from "./FaqBox.vue?vue&type=template&id=64ec591c&scoped=true&"
import script from "./FaqBox.vue?vue&type=script&lang=js&"
export * from "./FaqBox.vue?vue&type=script&lang=js&"
import style0 from "./FaqBox.vue?vue&type=style&index=0&id=64ec591c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ec591c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VIcon,VImg,VSpacer})
